import React, { useState, useEffect } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Col,
    Row,
    FormFeedback,
} from "reactstrap";

const AddressModal = ({ isOpen, toggle, address, onSubmit }) => {
  const [formData, setFormData] = useState({
    id: null, 
    external_id: "",
    name: "",
    street_address_1: "",
    street_address_2: "",
    city: "",
    state_province: "",
    postal_code: "",
    country: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (address) {
      setFormData({
        id: address.id || null,
        external_id: address.external_id || "",
        name: address.name || "",
        street_address_1: address.street_address_1 || "",
        street_address_2: address.street_address_2 || "",
        city: address.city || "",
        state_province: address.state_province || "",
        country: address.country || "",
        postal_code: address.postal_code || "",
      });
    } else  {
      setFormData({
        external_id: "",
        name: "",
        street_address_1: "",
        street_address_2: "",
        city: "",
        state_province: "",
        postal_code: "",
        country: "",
      });
    }
  }, [address, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors({ ...errors, [name]: "" }); // clear error on change
  };

  const submitHandler = (e) => {
    e.preventDefault();
    let newErrors = {};
    if (!formData.external_id.trim()) {
      newErrors.external_id = "External ID is required";
    }
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
      onSubmit(formData);
      toggle();
  };

  return (
    <Modal className={`modal-user-address modal-lg`} isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        <h3 className="mb-4">{address ? "Edit Address" : "Add Address"}</h3>
      </ModalHeader>
      <Form onSubmit={submitHandler}>
        <ModalBody className="text-left">
            <Row form>
            <Col md={6}>
          <FormGroup>
            <Label for="external_id">External ID *</Label>
            <Input
              type="text"
              name="external_id"
              id="external_id"
              value={formData.external_id}
              onChange={handleChange}
              placeholder="Enter external ID"
              invalid={!!errors.external_id}
            />
            {errors.external_id && <FormFeedback>{errors.external_id}</FormFeedback>}
          </FormGroup>
            </Col>

            <Col md={6}>
          <FormGroup>
            <Label for="name">Name *</Label>
            <Input
              type="text"
              name="name"
              id="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter name"
              invalid={!!errors.name}
            />
            {errors.name && <FormFeedback>{errors.name}</FormFeedback>}
          </FormGroup>
          </Col>
          </Row>

          <Row form>
            <Col md={6}>
          <FormGroup>
            <Label for="street_address_1">Street Address 1</Label>
            <Input
              type="text"
              name="street_address_1"
              id="street_address_1"
              value={formData.street_address_1}
              onChange={handleChange}
              placeholder="Enter street address 1"
            />
          </FormGroup>
            </Col>

            <Col md={6}>
        <FormGroup>
            <Label for="street_address_2">Street Address 2</Label>
            <Input
              type="text"
              name="street_address_2"
              id="street_address_2"
              value={formData.street_address_2}
              onChange={handleChange}
              placeholder="Enter street address 2"
            />
          </FormGroup>
            </Col>  
            </Row>
            <Row form>
            <Col md={6}>
          <FormGroup>
            <Label for="city">City</Label>
            <Input
              type="text"
              name="city"
              id="city"
              value={formData.city}
              onChange={handleChange}
              placeholder="Enter city"
            />
          </FormGroup>
           </Col>
            <Col md={6}>
          <FormGroup>
            <Label for="state_province">State/Province</Label>
            <Input
              type="text"
              name="state_province"
              id="state_province"
              value={formData.state_province}
              onChange={handleChange}
              placeholder="Enter state"
            />
          </FormGroup>
           </Col>
          </Row>

          <Row form>
            <Col md={6}>
          <FormGroup>
            <Label for="postal_code">Postal Code</Label>
            <Input
              type="text"
              name="postal_code"
              id="postal_code"
              value={formData.postal_code}
              onChange={handleChange}
              placeholder="Enter postal code"
            />
          </FormGroup>
          </Col>
            <Col md={6}>
          <FormGroup>
            <Label for="country">Country</Label>
            <Input
              type="text"
              name="country"
              id="country"
              value={formData.country}
              onChange={handleChange}
              placeholder="Enter country"
            />
          </FormGroup>
           </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button color="primary" type="submit">
            {address ? "Update" : "Save"}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};
export default AddressModal;


